export const materialRequisitionApiBase = 'configuration/product-category'
export const materialRequisitionListApi = materialRequisitionApiBase + '/list'
export const materialRequisitionStoreApi = materialRequisitionApiBase + '/store'
export const materialRequisitionUpdateApi = materialRequisitionApiBase + '/update'
export const materialRequisitionToggleStatusApi = materialRequisitionApiBase + '/toggle-status'
export const rawMaterialInfoById = materialRequisitionApiBase + '/raw-material-info-data'
export const getRequisitionIdApi = materialRequisitionApiBase + '/last-requisition-id'
export const userListApi = 'user/users-by-designation-id'

//  promotion-entry
export const promotionEntryListApi = 'promotion-management/promotion-entry/list'
export const promotionEntryStoreApi = 'promotion-management/promotion-entry/store'
export const promotionEntryUpdateApi = 'promotion-management/promotion-entry/update'
export const promotionEntryToggleStatusApi = 'promotion-management/promotion-entry/toggle-status'
export const promotionEntryDestroyApi = 'promotion-management/promotion-entry/destroy'

// dashboard
export const promotionDashboard = 'promotion-management/dashboard'
export const promotionEntryFileUploadApi = 'promotion-management/promotion-entry/file-upload'
